import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function PageTitle({ subtitle, align = 'center', sx }) {
  return (
    <Stack spacing={0.7} alignItems={align} sx={sx}>
      <Typography
        component={RouterLink}
        to="/"
        variant="h2"
        sx={{
          fontWeight: 900,
          fontSize: { xs: '2rem', sm: '2.8rem', md: '3.75rem' },
          letterSpacing: '0.04em',
          textDecoration: 'none',
          lineHeight: 1,
          background: 'linear-gradient(135deg, #1d4ed8 0%, #0f766e 90%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          '&:hover': {
            opacity: 0.9,
          },
          '&:focus-visible': {
            outline: '2px solid #1d4ed8',
            outlineOffset: 4,
            borderRadius: 2,
          },
        }}
      >
        Altessera
      </Typography>
      {subtitle ? (
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ fontWeight: 500, fontSize: { xs: '0.92rem', sm: '1rem' } }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Stack>
  );
}

export default PageTitle;